var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('ModalOverlay',[_c('ModalBody',{on:{"close":function($event){return _vm.$emit('change', false)}}},[_vm._t("default")],2)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }